<template>
<!-- 插入广告列表 -->
  <div v-if="list && list.length>0" class="More-main">
      <!-- <h2 class="title">更多推荐</h2> -->
      <ul>
          <li v-for="(item,index) in list" :key="index">
              <img v-if="item.image_url" :src="item.image_url" alt="">
              <img v-else src="@a/advertising_03.png" alt="">
              <div class="flex-text">
                  <h3>{{item.title}}</h3>
                  <a :href="item.link">{{item.btn_text}}</a>
              </div>
          </li>
      </ul>
  </div>
</template>

<script>
import { ad} from '@/api/measurement'
export default {
    data(){
        return{
            list:[]
        }
    },
    methods:{
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            ad().then((data) => {
                if (data.code == 10002) {
                    this.$toast(data.data.msg);
                    return false;

                }
                let val = data.ad?data.ad:{
                    title:'“点击领取提升职业竞争力的三大工具”',
                    link:'https://wx662871f607e1bfa4.h5.xiaoe-tech.com/content_page/eyJ0eXBlIjoiMiIsInJlc291cmNlX3R5cGUiOjQsInJlc291cmNlX2lkIjoibF81ZjA2ZjExNGU0YjA5YzE0MTJlM2M1ZmEiLCJhcHBfaWQiOiJhcHBUWTJHR3VVYTU3ODkiLCJwcm9kdWN0X2lkIjoiIn0'
                };
                this.list = [val];
                //关闭加载中
                this.$emit('loadingHandle',false);
            }).catch(err=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
            })
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss">
.More-main{
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 12px;
    padding: 30px;
    .title{
        margin-bottom: 30px;
        font-size: 36px;
        color: #333333;
    }
    ul{
        display: flex;
        flex-direction: column;
        li{
            display: flex;
            img{
                width: 282px;
                height: 176px;
                margin-right: 20px;
            }
            .flex-text{
                flex: 1;
                h3{   
                    font-weight: bold;
                    font-size: 32px;
                    line-height: 40px;
                    text-align: left;
                    color: #333333;
                }
                a{
                    display: block;
                    border-radius: 25px;
                    background-color: #EB5032;
                    color: #ffffff;
                    width: 188px;
                    line-height: 50px;
                    margin-top: 15px;
                    font-size: 26px;
                    text-align: center;
                }
            }
            
        }
    }
}
</style>